import { getLocalStorage } from "~/services/LocalStorage/localStorage";

export const COOKIE_CATEGORY_KEYS = [
  "analytics",
  "ads",
  "personalization",
  "userData",
] as const;

export type CookieCategory = (typeof COOKIE_CATEGORY_KEYS)[number];

export type CookieConsent = Record<CookieCategory, boolean>;

export const COOKIE_DECISION_KEYS = {
  agreement: "cookie_agreement",
  essential: "cookie_essential",
} as const;

export const readCookieConsent = (): CookieConsent => ({
  analytics: getLocalStorage("cookie_consent_analytics") === true,
  ads: getLocalStorage("cookie_consent_ads") === true,
  personalization: getLocalStorage("cookie_consent_personalization") === true,
  userData: getLocalStorage("cookie_consent_userData") === true,
});
